import React from 'react';
import EnrollersTable from './components/EnrollersTable/EnrollersTable';

const EnrollersList = () => {
  return <EnrollersTable />;
};

export default EnrollersList;
